
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ActiveIcon from '@mui/icons-material/Check';
import InactiveIcon from '@mui/icons-material/Close';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import { alpha, useTheme } from '@mui/material/styles';

import Paper from '@mui/material/Paper';
import { MobileSubscription } from '../../interface/MobileSubscription';
import moment from "moment"

interface SubscriptionsListProps
{   
    subscriptions: MobileSubscription[]
    onEdit: (item: MobileSubscription) => void
}

export const SubscriptionsList = ({ subscriptions, onEdit }: SubscriptionsListProps) => {
    const theme = useTheme()

    return (
     <TableContainer component={Paper} sx={styles.container(theme)}>
      <Table sx={styles.table} aria-label="subscriptions table">
        <TableHead>
          <TableRow>
            <TableCell sx={styles.header(theme)}>Active</TableCell>
            <TableCell sx={styles.header(theme)}>User</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>Product</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>Created</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>Last bill</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>Next bill</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>Updated</TableCell>
            <TableCell align="right" sx={styles.header(theme)}>Platform</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {subscriptions?.map((row) => (
            <TableRow
              onClick={() => onEdit(row)}
              hover
              key={row._id}
              sx={styles.row(theme)}
            >
             <TableCell component="th" scope="row" align="left" sx={styles.cell(theme)}>
                <Chip
                  icon={row.isActive ? <ActiveIcon /> : <InactiveIcon />}
                  label={row.isActive ? "Active" : "Inactive"}
                  sx={styles.statusChip(theme, row.isActive)}
                />
              </TableCell>
              <TableCell sx={styles.cell(theme)}>
                <Typography fontWeight={700}>{row.email}</Typography>
              </TableCell>
              <TableCell align="right" sx={styles.cell(theme)}>
                <Typography fontWeight={700}>{row.productId}</Typography>
              </TableCell>
              <TableCell align="right" sx={styles.cell(theme)}>{moment(row.createdAt).fromNow()}</TableCell>
              <TableCell align="right" sx={styles.cell(theme)}>{row.lastBillDate ? moment(row.lastBillDate).fromNow() : "-"}</TableCell>
              <TableCell align="right" sx={styles.cell(theme)}>{row.nextBillDate ? moment(row.nextBillDate).fromNow() : "-"}</TableCell>
              <TableCell align="right" sx={styles.cell(theme)}>{row.lastUpdated ? moment(row.lastUpdated).fromNow() : "never"}</TableCell>
              <TableCell align="right" sx={styles.cell(theme)}>
                <Box sx={styles.platform(theme)}>
                  {row.androidPurchaseToken ? <AndroidIcon fontSize="small" /> : <AppleIcon fontSize="small" />}
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    )
}

const styles = {
    container: (theme: any) => ({
        borderRadius: "18px",
        border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.55)}`,
        backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.6),
        boxShadow: "none",
    }),
    table: {
        minWidth: 980,
    },
    header: (theme: any) => ({
        fontWeight: 700,
        color: alpha(theme.palette.text.primary, 0.7),
        backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.4),
        borderBottomColor: alpha(theme.palette.text.primary, 0.12),
    }),
    row: (theme: any) => ({
        cursor: "pointer",
        '&:last-child td, &:last-child th': { border: 0 },
        '&:hover': {
            backgroundColor: alpha(theme.palette.info.main, theme.palette.mode === "dark" ? 0.08 : 0.06),
        },
    }),
    cell: (theme: any) => ({
        borderBottomColor: alpha(theme.palette.text.primary, 0.1),
        py: 2,
    }),
    statusChip: (theme: any, active: boolean) => ({
        borderRadius: "999px",
        backgroundColor: active
            ? alpha(theme.palette.success.main, theme.palette.mode === "dark" ? 0.18 : 0.14)
            : alpha(theme.palette.error.main, theme.palette.mode === "dark" ? 0.16 : 0.12),
        color: active ? theme.palette.success.light : theme.palette.error.light,
        '& .MuiChip-label': {
            fontWeight: 700,
        },
        '& .MuiChip-icon': {
            color: "inherit",
        },
    }),
    platform: (theme: any) => ({
        width: 34,
        height: 34,
        marginLeft: "auto",
        borderRadius: "10px",
        display: "grid",
        placeItems: "center",
        backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.05 : 0.68),
        border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.4)}`,
    }),
}
